import React, { useCallback, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs, { Dayjs } from "dayjs";
import { Month } from "src/components/Calendar/components";
import { Day } from "src/components/Calendar/components/Month/components";
import { Tooltip } from "src/components/Calendar/components/Month/components/Day/components";
import { HolidaysType, months } from "src/constants/calendar";
import { dayOffColor, holidayColor } from "src/constants/colors";
import { getDateMonthForYear } from "src/utils/calendar";

const MonthViewDay = (
  props: PickersDayProps<Dayjs> & {
    workTimePeriod?: any;
    holidayPeriod?: any;
    dayOffPeriod?: any;
  }
) => {
  const {
    workTimePeriod = {},
    holidayPeriod = {},
    dayOffPeriod = {},
    outsideCurrentMonth,
    day,
    ...rest
  } = props;

  const isSelected = dayjs().format("DD/MM/YYYY") === day.format("DD/MM/YYYY");

  const weekTitle = day.format("dd");
  const dayTitle = day.format("D");

  if (isSelected) {
    console.log(isSelected, "hello world?");
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      {isSelected ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "54.5px",
            width: "36px",
            backgroundColor: "#F3F3F3",
            borderBottom: "1px solid #D6D6DB",
          }}
        >
          <Box
            sx={{
              marginTop: "10px",
              display: "flex",
              flexDirection: "column",
              width: "24px",
              height: "36px",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "6px",
              backgroundColor: "#BF295C",
            }}
          >
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: "500",
                color: "white",
              }}
            >
              {weekTitle}
            </Typography>
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: "500",
                color: "white",
              }}
            >
              {dayTitle}
            </Typography>
          </Box>
          <Box
            sx={{
              height: "12px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                height: "100%",
                background: "linear-gradient(to bottom, #BF295C, #BF295C)",
                backgroundSize: "30px 16px",
                width: "1px",
              }}
             />
          </Box>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "60px",
            width: "36px",
            backgroundColor: "#F3F3F3",
            borderBottom: "1px solid #D6D6DB",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "24px",
              height: "36px",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: "500",
                color: outsideCurrentMonth ? "#B9B9B9" : "#9D9D9D",
              }}
            >
              {weekTitle}
            </Typography>
            <Typography
              sx={{
                fontSize: "11px",
                fontWeight: "500",
                color: outsideCurrentMonth ? "#B9B9B9" : "#080808",
              }}
            >
              {dayTitle}
            </Typography>
          </Box>
        </Box>
      )}
      <Box
        sx={{
          height: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            height: "100%",
            background: isSelected
              ? "linear-gradient(to bottom, #BF295C, #BF295C)"
              : "linear-gradient(to bottom, #D6D6DB 50%, transparent 50%)",
            backgroundSize: "30px 16px",
            width: "1px",
          }}
         />
      </Box>
    </Box>
  );
};

interface MonthViewProps {
  workTimePeriod: any;
  holidayPeriod: any;
  dayOffPeriod: any;
  yearState: number;
  monthState: string;
}

export const MonthView = ({
  workTimePeriod,
  holidayPeriod,
  dayOffPeriod,
  yearState,
  monthState,
}: MonthViewProps) => {
  const referenceDate = useMemo(
    () => dayjs(getDateMonthForYear(yearState.toString(), monthState)),
    [yearState, monthState]
  );

  console.log(referenceDate);

  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        // justifyContent: 'center',
        paddingLeft: "32px",
        paddingBottom: "54px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          // maxWidth: '1168px',
          // padding: '0px 32px 32px 0px',
          border: "1px solid #D6D6DB",
          borderRadius: "6px",
        }}
      >
        <Box>
          <DateCalendar
            showDaysOutsideCurrentMonth
            fixedWeekNumber={6}
            views={["day"]}
            slots={{
              day: MonthViewDay,
            }}
            slotProps={{
              day: {
                workTimePeriod,
                holidayPeriod,
                dayOffPeriod,
              } as any,
            }}
            value={referenceDate}
            // referenceDate={referenceDate}
            reduceAnimations
            readOnly
            sx={{
              height: "100%",
              maxHeight: "100%",
              // maxWidth: '252px',
              width: "100%",

              "& >div, & >div > div, & .MuiPickersSlideTransition-root": {
                height: "100%",
              },

              "& .MuiPickersCalendarHeader-root": {
                display: "none",
              },

              "& .MuiDayCalendar-monthContainer": {
                display: "flex",
                height: "100%",
              },

              "& .MuiDayCalendar-header": {
                display: "none",
                borderBottom: "1px solid #F3F3F3",

                "& .MuiDayCalendar-weekDayLabel": {
                  height: "32px",
                  width: "32px",
                  margin: "0px",
                  marginLeft: "4px",
                  fontWeight: "700",
                  fontSize: "11px",
                  color: "#828282",
                  cursor: "default",
                  userSelect: "none",

                  "&:first-of-type": {
                    marginLeft: "0px",
                    marginRight: "2px",
                  },

                  "&:last-child": {
                    marginLeft: "6px",
                  },
                },
              },

              "& .MuiPickersDay-root:focus, & .MuiPickersDay-root:hover": {
                backgroundColor: "transparent",
              },

              "& .Mui-selected:hover, & .Mui-selected:focus": {
                backgroundColor: "#BF295C",
              },

              "& .Mui-selected.MuiButtonBase-root": {
                color: "#FFFFFF",
              },

              "& .MuiButtonBase-root": {
                margin: "0px",
                width: "34px",
                height: "100%",
                fontSize: "11px",
                fontWeight: "500",
                color: "#080808",

                "&:not(.MuiPickersDay-dayOutsideMonth)": {
                  "&.MuiPickersDay-today": {
                    borderColor: "#BF295C",
                    color: "#BF295C",
                    backgroundColor: "white",

                    "&.holiday": {
                      borderColor: holidayColor,
                      color: holidayColor,
                      backgroundColor: "white",
                    },

                    "&.dayOff": {
                      borderColor: dayOffColor,
                      color: dayOffColor,
                      backgroundColor: "white",
                    },
                  },

                  "&.dayOff": {
                    backgroundColor: dayOffColor,
                    color: "white",
                  },

                  "&.holiday": {
                    backgroundColor: holidayColor,
                    color: "white",
                  },
                },

                "&.MuiPickersDay-dayOutsideMonth": {
                  border: "none !important",
                },
              },

              "& .MuiDayCalendar-weekContainer": {
                margin: "0px",
              },

              "& .MuiPickersDay-dayOutsideMonth": {
                color: "#B9B9B9",
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
